import React from "react";

const LOGO_URL = "/languagecert-logo.svg";

export const Header = () => {
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 w-full bg-white/85 backdrop-blur-md border-b border-[#E2E8F0]"
        >
            <div className="max-w-6xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3"
                    aria-label="LanguageCert"
                >
                    <img
                        src={LOGO_URL}
                        alt="LanguageCert"
                        className="h-7 sm:h-8 w-auto object-contain"
                        data-testid="header-logo-image"
                    />
                </a>
                <div
                    data-testid="header-trust-badge"
                    className="hidden sm:flex items-center gap-2 text-xs text-[#475569]"
                >
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#16A34A]" />
                    Official exam booking codes
                </div>
            </div>
        </header>
    );
};

export default Header;
